import React from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = React.useState(false);

  React.useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleSettings = () => {
    alert('Οι ρυθμίσεις cookies θα είναι διαθέσιμες σύντομα. Για περισσότερες πληροφορίες, δείτε την Πολιτική Απορρήτου μας.');
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Χρήση Cookies</h3>
          <p>
            Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στον ιστότοπό μας, 
            να αναλύσουμε την επισκεψιμότητα και να εξατομικεύσουμε το περιεχόμενο. 
            Τα cookies μας βοηθούν να κατανοήσουμε πώς χρησιμοποιείτε τον ιστότοπο και να βελτιώσουμε τις υπηρεσίες μας.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        <div className="cookie-actions">
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">
            Αποδοχή όλων
          </button>
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;